import FormActions from "./SignUp-SignIn/FormActions";
import FormFields from "./SignUp-SignIn/FormFields";
import FormHeader from "./SignUp-SignIn/FormHeader";
import {
  Divider,
  Grid,
  Paper,
  styled,
  Typography
  } from "@mui/material";
import { signUpFieldsList } from "./SignUp-SignIn/fieldsLists";
import { SignUpFormFooter } from "./SignUp-SignIn/FormFooter";
import { SignUpFormProps } from "../../interfaces/ISginUpSignInForm";

const Container = styled("div")(({ theme }) => ({
  alignItems: "center",
  display: "flex",
  height: "100vh",
  justifyContent: "center",
  padding: theme.spacing(2),
}));

export default function SignUpForm({
  formData,
  formErrors,
  onChange,
  onClickSignUp,
  loading,
  error,
}: SignUpFormProps) {
  return (
    <Container>
      <Grid container height="100vh" justifyContent="center" alignItems="center">
        <Grid item>
          <Paper sx={{ p: 3 }}>
            <Grid container direction="column" height="auto" spacing={2}>
              <Grid item xs={12} textAlign="center">
                <FormHeader />
              </Grid>
              <Grid item xs={12}>
                <FormFields
                  fieldDirection="row"
                  fieldsList={signUpFieldsList}
                  formData={formData}
                  formErrors={formErrors}
                  onChange={onChange}
                />
              </Grid>
              <Grid item xs={12}>
                <FormActions onClickSignUp={onClickSignUp} loading={loading} error={error} />
              </Grid>
              {loading && (
                <Grid item xs={12}>
                <Typography variant="body1" textAlign="center">
                    Trwa tworzenie Twojego konta... Może to zająć kilka sekund...
                  </Typography>
                </Grid>
              )}
              <Grid item xs={12}>
                <Divider />
              </Grid>
              <Grid item xs={12}>
                <SignUpFormFooter />
              </Grid>
            </Grid>
          </Paper>
        </Grid>
      </Grid>
    </Container>
  );
}
